<template>
  <div class="finishSet">
   <el-row >
    <el-col :span="14">
      <previewMail :formData="formData" :attachmentVos="attachmentVos"/>
    </el-col>
    <el-col :span="10">
      <previewDetail :formData="formData" :signature="signature" :filterGroupArr="filterGroupArr"/>
    </el-col>
   </el-row>
  </div>
</template>
<script>
import previewDetail from "@/components/intellect-marketing/mailDetail/previewDetail"
import previewMail from "@/components/intellect-marketing/mailDetail/previewMail"
export default {
  components:{
    previewDetail,previewMail
  },
  props:{
    formData:{
      type:Object,
      default:{}
    },
    signature:{
      type:String,
      default:''
    },
    // submitTotal:{
    //   type:String,
    //   default:''
    // },
    filterGroupArr:{
      type:Array,
      default:[]
    },
    tempUrlShow:{
      type:Boolean,
      default:false
    },
    attachmentVos:{
      type:Array,
      default:[]
    }
  },
  data(){
    return{
    
    }
  },
}
</script>
<style lang="scss" scoped>
.finishSet{
  margin-top: 20px;
  padding:0 10px 0 40px;
}
</style>